module.exports = __webpack_public_path__ + "static/media/purple-step.b730b4d7.svg";